/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

const isRetailOrSale = (prices) => {
    const retail = prices?.[0]?.value;
    const sale = prices?.[1]?.value;

    if (retail && sale && sale < retail) {
        return sale;
    }
    return retail;
};

export default isRetailOrSale;
